export const MAIN_URL = 'https://Farm-Easy-Backend.surajgupta07.repl.co';
export const CART_URL = `${MAIN_URL}/cart`;
export const WISHLIST_API = `${MAIN_URL}/wishlist`;
